import { render, staticRenderFns } from "./KisList.vue?vue&type=template&id=1dba280e"
import script from "./KisList.js?vue&type=script&lang=js&external"
export * from "./KisList.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports